import { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';

/**
 * PaymentCallbackPage — SPA-страница, на которую Invizo редиректит
 * после успешной оплаты (result_url = /payment-callback).
 *
 * Задача:
 * 1. Уведомить исходную вкладку через window.postMessage — та немедленно
 *    запросит статус транзакции вместо ожидания следующего поллинга.
 * 2. Закрыть себя — если оплата открывалась в popup-окне (штатный сценарий).
 *    Если в новой вкладке (fallback при блокировке popup) — страница останется
 *    открытой с сообщением «можно закрыть».
 */
export function PaymentCallbackPage() {
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    // Уведомляем opener об успешной оплате
    try {
      if (window.opener) {
        window.opener.postMessage({ type: 'xpanda_payment_done' }, window.location.origin);
      }
    } catch {
      // cross-origin или opener недоступен — ничего страшного
    }

    // Небольшая задержка — даём postMessage дойти до opener, затем закрываем
    const timer = setTimeout(() => {
      setCanClose(true);
      window.close();
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center px-4">
      <div className="text-center space-y-4">
        <CheckCircle2 className="w-16 h-16 text-green-400 mx-auto" />
        <h1 className="text-2xl font-bold text-white">Оплата подтверждена</h1>
        <p className="text-[#8b949e]">
          {canClose
            ? 'Можете закрыть это окно и вернуться на сайт.'
            : 'Закрываем окно...'}
        </p>
      </div>
    </div>
  );
}
